export default __webpack_public_path__ + "static/media/gas.e82f5834.svg";